import * as React from 'react';
import { UserMessage, UserMessageType } from 'app/types-shared';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { deepEquals } from 'app/infrastructure/js';
import { MdClose } from 'react-icons/md';
import styles from './toastify-override.scss';
import { Link } from 'ui';

interface MessageProps {
  messages: UserMessage[];
}

const CustomCloseButton = (toastProps: any) => {
  const { closeToast, ...validProps } = toastProps;
  return <MdClose {...validProps} className={styles.customCloseButton} />;
};

export class MessagePanel extends React.PureComponent<MessageProps> {
  public componentDidUpdate(prevProps: MessageProps) {
    const { messages: currentMessages } = prevProps;
    const { messages: pendingMessages = [] } = this.props;

    if (
      deepEquals(currentMessages, pendingMessages) ||
      !pendingMessages.length
    ) {
      return;
    }

    pendingMessages.forEach(message => toast.dismiss(message.id));

    const icon = <CustomCloseButton width="20" height="20" />;

    pendingMessages
      .filter(m => currentMessages.indexOf(m) === -1)
      .forEach(m => {
        const mgs = (
          <div>
            {m.title && <div className={styles.title}>{m.title}</div>}
            {m.link
              ? <Link url={m.link} linkText={m.message}><div className={styles.link}>{m.message}</div></Link>
              : <div>{m.message}</div>}
          </div>
        );

        if (m.type === UserMessageType.success) {
          toast.success(mgs, {
            position: toast.POSITION.TOP_LEFT,
            closeButton: icon,
            className: styles.success,
            progressClassName: styles.successProgress
          });
        }
        if (m.type === UserMessageType.error) {
          toast.error(mgs, {
            position: toast.POSITION.TOP_LEFT,
            closeButton: icon,
            className: styles.error,
            progressClassName: styles.errorProgress
          });
        }
        if (m.type === UserMessageType.info) {
          toast.info(mgs, {
            position: toast.POSITION.TOP_LEFT,
            closeButton: icon,
            className: styles.info,
            progressClassName: styles.infoProgress
          });
        }
      });
  }

  public componentWillUnmount() {
    const { messages = [] } = this.props;
    messages.forEach(message => toast.dismiss(message.id));
  }

  public render() {

    return <ToastContainer
      position="top-left"
      style={{ zIndex: 2001 }}
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      className={styles.container}
      toastClassName={styles.body}
      closeOnClick
      pauseOnHover
      theme="colored"
      icon={false}
    />;
  }
}
